export default __webpack_public_path__ + "913b5c9f94d46d9702bee6e1ac2e1105.png";